var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminNextIframe',{attrs:{"path":"/dashboard-stock/","with-currency":"","query":{ clientId: _vm.firstClientId }}})
}
var staticRenderFns = []

export { render, staticRenderFns }